import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { RequestStrategyEnum, TransferRequestsApi, WithSignal, type TransferRequestGetFxRateRequest } from '@shared/api';
import { ApiUtilsV2 } from '@shared/utils';

const getFxRateEffect = createEffect(({ signal, ...request }: WithSignal<TransferRequestGetFxRateRequest>) =>
  TransferRequestsApi.getFxRate(request, signal),
);
const clearEvent = createEvent();

const setRateEvent = createEvent<number>();

const $dataStore = createStore<number | null>(null)
  .on(getFxRateEffect.done, (_, data) => data.result.data ?? null)
  .on(setRateEvent, (_, value) => value)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getFxRateEffect.pending, (_, data) => data)
  .on(getFxRateEffect.fail, () => false)
  .on(getFxRateEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getFxRateEffect, () => null)
  // .on(getFxRateEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}.`, data.error.message))
  .on(getFxRateEffect.fail, () => 'Something went wrong while fetching Rate. Please try again')
  .on(getFxRateEffect.done, () => null)
  .on(setRateEvent, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $transferRequestsGetFxRateStore = {
  events: {
    getFxRate: ApiUtilsV2.wrapperApi(getFxRateEffect, RequestStrategyEnum.Debounce).trigger,
    setRate: setRateEvent,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
